import React, {useState} from 'react';
import {ActionButton} from '@components/button/ActionButton';
import {colours, iconSize, spacing} from '@styles/Style';
import {GetGlobalTheme} from '../../../Tools/DisplayTools';
import Company from '@components/switchAccount/Company';
import {CompanyData} from '@utils/types';
import {switchCompany} from '@utils/companyTools';
import EditField from '../editElements/EditField';
import {Modal} from 'react-native';
import {
  ButtonWrapper,
  CancelButton,
  CancelButtonText,
  CloseButton,
  CompanyContainer,
  CompanySection,
  Container,
  HeaderText,
  MiddleContainer,
  OpenButton,
  OpenButtonText,
  SearchBar,
  SearchBarWrapper,
  SearchIconStyle,
  SwitchAccountFooter,
} from '@components/switchAccount/SwitchAccount.styles';
import {translate} from '@utils/languageTools';
import {ColumnContainer, HeaderTextContainer, RowContainer} from '@src/styles/primitiveComponents';
import styled from 'styled-components/native';
import {isDesktopScreen, isMobileOrTabletScreen} from '@tools/displayTools';

let doubleClickable = false;

const ModalBackground = styled(ColumnContainer)`
  background-color: rgba(63, 63, 63, 0.4);
  width: 100%;
  height: 100%;
  justify-content: ${isMobileOrTabletScreen() ? 'flex-end' : 'center'};
`;

const Header = styled(RowContainer)`
  align-items: center;
  width: 100%;
  border-style: solid;
  border-width: 0;
  border-bottom-width: 1px;
  border-color: ${colours[GetGlobalTheme()].grey400};
  padding: 0 ${spacing.space16}px;
  padding-top: ${isMobileOrTabletScreen() ? spacing.space12 : spacing.space24}px;
  padding-bottom: ${isMobileOrTabletScreen() ? spacing.space12 : spacing.space24}px;
`;

export const SwitchAccount = () => {
  const [companyArr] = useState<CompanyData[]>(global.userData.complist);
  const [selectedCompanyUuid, setSelectedCompanyUuid] = useState<string>(global.userData.selectedcomp);
  const [searchParams, setSearchParams] = useState<string>('');

  const doubleClickDurationInMS = 350;

  function handleCompanyPress(companyUuid: string) {
    if (selectedCompanyUuid === companyUuid && doubleClickable) {
      switchCompany(selectedCompanyUuid);
      closeSwitchAccount();
      return;
    }
    if (isDesktopScreen()) {
      doubleClickable = true;
      setTimeout(disableDoubleClick, doubleClickDurationInMS);
    }
    setSelectedCompanyUuid(companyUuid);
  }

  function disableDoubleClick() {
    doubleClickable = false;
  }

  function closeSwitchAccount() {
    global.showSwitchAccount({show: false});
  }

  function handleCancelButtonClick() {
    closeSwitchAccount();
  }

  function handleOpenButtonClick() {
    switchCompany(selectedCompanyUuid);
    closeSwitchAccount();
  }

  function filterCompaniesBySearch(text) {
    setSearchParams(text.toUpperCase());
  }

  return (
    <Modal transparent={true}>
      <ModalBackground>
        <Container>
          <Header>
            <HeaderTextContainer>
              <HeaderText> {translate('SwitchAccounts')} </HeaderText>
              <ActionButton
                onPress={closeSwitchAccount}
                title={''}
                style={CloseButton}
                iconName={'CrossIcon'}
                iconColor={colours[GetGlobalTheme()].primary}
                iconSize={12}
                backgroundColor={colours[GetGlobalTheme()].iconButtonBG}
                hoverColor={colours[GetGlobalTheme()].grey100}
              />
            </HeaderTextContainer>
          </Header>
          <MiddleContainer>
            <CompanySection>
              <EditField
                title={''}
                name={''}
                value={''}
                placeholder={translate('SearchCompany') + '...'}
                placeholderTextColor={colours[GetGlobalTheme()].grey600}
                onChangeText={(text) => filterCompaniesBySearch(text)}
                inputStyle={SearchBar}
                wrapperStyle={SearchBarWrapper}
                iconName={'SearchIcon'}
                iconStyle={SearchIconStyle}
                iconHeight={iconSize.iconSize}
              />
              <CompanyContainer>
                {companyArr
                  .filter(({name}) => !searchParams || name.toUpperCase().includes(searchParams))
                  .map(({name, uuid}) => (
                    <Company
                      companyName={name}
                      uuid={uuid}
                      onPress={handleCompanyPress}
                      selected={selectedCompanyUuid === uuid}
                    />
                  ))}
              </CompanyContainer>
            </CompanySection>
          </MiddleContainer>
          <SwitchAccountFooter>
            <ButtonWrapper>
              <ActionButton
                onPress={handleCancelButtonClick}
                title={translate('Cancel')}
                style={CancelButton}
                textStyle={CancelButtonText}
              />
              <ActionButton
                onPress={handleOpenButtonClick}
                title={translate('Open')}
                style={OpenButton}
                textStyle={OpenButtonText}
              />
            </ButtonWrapper>
          </SwitchAccountFooter>
        </Container>
      </ModalBackground>
    </Modal>
  );
};
